"use client";

import {
  Toaster as SonnerToaster,
  ToasterProps,
  toast as sonnerToast,
} from "sonner";

export const toast = sonnerToast;

export const Toaster = (props: ToasterProps) => {
  return (
    <SonnerToaster
      theme="light"
      className="toaster group"
      // style={
      //   {
      //     "--normal-bg": "var(--popover)",
      //     "--normal-text": "var(--popover-foreground)",
      //     "--normal-border": "var(--border)",
      //   } as React.CSSProperties
      // }
      {...props}
    />
  );
};
